const isType = (f, type = 'image') => f['agent_attachedfile.mime'] && f['agent_attachedfile.mime'].indexOf(`${type}/`) == 0;


const getImgFileName = fact => getTypeFileName(fact, 'image');
const knownTypes = {
  image: true,
  video: true,
};

const getTypeFileName = (fact, type = 'image') => {
  if (!fact) return false;
  if (isType(fact, type)) return fact['agent_attachedfile.data'];
  const child = fact.children && fact.children.find(f => isType(f, type));
  if (!child) return false;
  const imageFileName = child['agent_attachedfile.data'];
  if (!fact['agent_attachedfile.data'] && !fact['agent_attachedfile.mime']) {
    fact['agent_attachedfile.data'] = imageFileName;
    fact['agent_attachedfile.mime'] = child['agent_attachedfile.mime'];
  }
  return imageFileName;
};


export class Fact {

  static isImage(fact) {
    return !!getTypeFileName(fact, 'image');
  }

  static isVideo(fact) {
    return !!getTypeFileName(fact, 'image');
  }

  static getImageFileName(fact) {
    return getTypeFileName(fact, 'image');
  }

  static getVideoFileName(fact) {
    return getTypeFileName(fact, 'video');
  }

  static getFactType(fact) {
    let type = '';
    const mime = fact['agent_attachedfile.mime'];
    if (mime) {
      type = mime.split('/')[0];
    }
    return knownTypes[type] ? type : '';
  }
}



// WEBPACK FOOTER //
// ./src/common/fact.js